import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { MediaHubApiService } from './media-hub-api.service'
import {
  Publisher,
  CreatePublisherRequest,
  UpdatePublisherRequest,
  PublisherResponse,
  PublishersListResponse,
} from '../models/publisher.model'

@Injectable({
  providedIn: 'root',
})
export class PublisherApiService {
  private readonly endpoint = '/publishers'

  private apiService = inject(MediaHubApiService)

  createPublisher(request: CreatePublisherRequest): Promise<PublisherResponse> {
    return this.apiService.postBase<CreatePublisherRequest, PublisherResponse>(this.endpoint, request)
  }

  createPublisher$(request: CreatePublisherRequest): Observable<PublisherResponse> {
    return this.apiService.postBaseRx<CreatePublisherRequest, PublisherResponse>(this.endpoint, request)
  }

  getAllPublishers(): Promise<PublishersListResponse> {
    return this.apiService.getBase<PublishersListResponse>(this.endpoint)
  }

  getAllPublishers$(): Observable<PublishersListResponse> {
    return this.apiService.getBaseRx<PublishersListResponse>(this.endpoint)
  }

  getPublisherById(id: string): Promise<PublisherResponse> {
    return this.apiService.getBase<PublisherResponse>(`${this.endpoint}/${id}`)
  }

  getPublisherById$(id: string): Observable<PublisherResponse> {
    return this.apiService.getBaseRx<PublisherResponse>(`${this.endpoint}/${id}`)
  }

  updatePublisher(id: string, request: UpdatePublisherRequest): Promise<PublisherResponse> {
    return this.apiService.putBase<UpdatePublisherRequest, PublisherResponse>(`${this.endpoint}/${id}`, request)
  }

  updatePublisher$(id: string, request: UpdatePublisherRequest): Observable<PublisherResponse> {
    return this.apiService.putBaseRx<UpdatePublisherRequest, PublisherResponse>(`${this.endpoint}/${id}`, request)
  }

  deletePublisher(id: string): Promise<{ message: string }> {
    return this.apiService.deleteBase<{ message: string }>(`${this.endpoint}/${id}`)
  }
}
